import React from 'react';

const Footer = () => {
    return (
        <footer className="bg-white text-primary text-center py-4 mt-auto border-top shadow-sm">
            <div className="container">
                <div className="my-3 d-flex justify-content-center gap-3">
                    <a href="https://facebook.com" className="text-primary fs-4">
                        <i className="bi bi-facebook"></i>
                    </a>
                    <a href="https://x.com" className="text-primary fs-4">
                        <i className="bi bi-twitter-x"></i>
                    </a>
                    <a href="https://www.instagram.com/local.hire" className="text-primary fs-4">
                        <i className="bi bi-instagram"></i>
                    </a>
                    <a href="/contact" className="text-primary fs-4">
                        <i className="bi bi-envelope"></i>
                    </a>
                </div>
                <p className="mb-1 fw-medium">&copy; {new Date().getFullYear()} Local Hire</p>
                <p className="mb-1">
                    <a href="#" className="text-decoration-none text-dark">Términos y condiciones</a> |
                    <a href="#" className="text-decoration-none text-dark">Accesibilidad</a> |
                    <a href="#" className="text-decoration-none text-dark">Ayuda</a> |
                    <a href="#" className="text-decoration-none text-dark">Defensa del Consumidor</a> |
                    <a href="#" className="text-decoration-none text-dark">Libro de quejas online</a>
                </p>
                <p className="mb-0 text-secondary">Dirección: Calle sin nombre sin número</p>
            </div>
        </footer>
    );
};

export default Footer;
